<div class="page-layout blank p-24" fusePerfectScrollbar>
  @if (organizations.length > 2) {
    <ng-select [items]="organizations" [(ngModel)]="orgId" bindLabel="name" bindValue="id"
      (change)="getData(); getEventsInfo();  getSubscription();  getCommunications(); getListRewads(); getListStatuses();">
      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
        <div style="margin: 10px 0;" class="card">
          <div class="card-body">
            <h2 class="card-title" style="margin: 1px;">{{item.name}}</h2>
            @if (item.organizationType) {
              <h6 class="card-subtitle mb-2 text-muted" style="margin: 1px;">
                @if (item.logo) {
                  <img height="40" width="40"
                    [src]="getImage(item.logo)"/>
                }
                {{item.organizationType.name}}
              </h6>
            }
          </div>
        </div>
      </ng-template>
    </ng-select>
  }

  <!--<mat-form-field>-->
  <!--<input matInput  type="text" ngxDaterangepickerMd autocomplete="false"-->
  <!--[(ngModel)]="selected" placeholder="Choose date"-->
  <!--(ngModelChange)="ngModelChange($event)"/>-->
<!--</mat-form-field>-->

@if (data) {
  <simple-card [data]="dataNumber"></simple-card>
  <simple-pie [name]="'userByTG'" [type]="'pie-grid'" [data]="dataTG"></simple-pie>
  <simple-pie [name]="'userStatistic'" [type]="'double-pie'" [data]="dataUsers"></simple-pie>
  <simple-pie [name]="'eventByType'"  [systemTyp]="'event'" [isTime]="isTime" (time)="changeTime($event)" [type]="'pie-grid'"
  [data]="dataEventType" [color]="eventTypeColor"></simple-pie>
  <simple-pie [name]="'eventStatisctic'"  [systemTyp]="'event'" [isTime]="isTime" (time)="changeTime($event)" [type]="'double-pie'"
  [data]="dataEvents"></simple-pie>
}
<ng-container>
  <simple-tree [name]="'eventPopular'" [systemTyp]="'event'" [isTime]="isTime" (time)="changeTime($event)" [data]="treemap"
  [color]="colorSchemeTree"></simple-tree>
</ng-container>
<ng-container>
  <simple-bar [name]="'mergeData'" [systemTyp]="'event'" [isTime]="isTime" (time)="changeTime($event)" [data]="subscription"></simple-bar>
</ng-container>
<simple-pie [name]="'communicationStatistic'" [type]="'pie-grid'" [data]="communication"></simple-pie>
<simple-list [name]="'rewards'" [type]="'reward'"  [data]="rewards"></simple-list>
<simple-list [name]="'statuses'" [type]="'status'"  [data]="statuses"></simple-list>
</div>
